import styled from '@emotion/styled';
import React from 'react';
import { Typography } from './Typography.jsx';
import logo from '../../../assets/MCR-V-4.png';

const StyledSidebarHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  height: auto;
  min-height: 80px;

  @media (max-width: 768px) {
    min-height: 72px;
    padding: 0 16px;
  }
`;

const StyledMobileSidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: auto;
  min-height: 64px;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    min-height: 56px;
  }
`;

const StyledLogoImage = styled.img`
  height: 48px;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

const StyledMobileLogoImage = styled.img`
  height: 48px;
  margin-right: ${({ rtl }) => (rtl ? '4px' : '10px')};
  margin-left: ${({ rtl }) => (rtl ? '10px' : '4px')};

  @media (max-width: 768px) {
    height: 40px;
  }
`;

const StyledTitleWrapper = styled.div`
  flex: 1; 
  text-align: center;
`;

export const SidebarHeader = ({ rtl, colour = '#BAC3CB', title, isMobile = false, imageSrc, ...rest }) => {
  return isMobile ? (
    <StyledMobileSidebarHeader {...rest}>
      <div>
        <StyledMobileLogoImage src={imageSrc ? `data:image/jpeg;base64,${imageSrc}` : logo} alt="Logo" rtl={rtl} />
        <StyledTitleWrapper>
          <Typography
            variant="subtitle1"
            fontWeight={700}
            color={colour}
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              padding: '0px 0px 0px 20px',
            }}
          >
            {title}
          </Typography>
        </StyledTitleWrapper>
      </div>
    </StyledMobileSidebarHeader>
  ) : (
    <StyledSidebarHeader {...rest}>
      <StyledLogoImage src={imageSrc ? `data:image/jpeg;base64,${imageSrc}` : logo} alt="Logo" />
      <StyledTitleWrapper>
        <Typography
          variant="subtitle1"
          fontWeight={700}
          color={colour}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
      </StyledTitleWrapper>
    </StyledSidebarHeader>
  );
};
